/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { stampOptions } from '../options/stamp.options';

/**
 * Stamp directive
 *
 * One-shot DOM rewrite driven by an `apply` function on the merged preset.
 * Product Tile uses `amb-stamp="callout_badges"` so sourced labels reuse the
 * merchandiser-authored Callout Badges markup (style, spacing, visibility).
 */
export const stampDirective = {
  /**
   * @protected
   */
  options: stampOptions,

  /**
   * Run the merged preset's `apply` on the host, if present.
   *
   * @param {HTMLElement} element Host carrying `amb-stamp`.
   * @param {object}      options Merged options from the compiler.
   */
  init(element, options = {}) {
    if (typeof options.apply === 'function') {
      options.apply(element);
    }
  },

  /**
   * No-op. Stamp is one-shot; cloned nodes leave with the tile.
   *
   * @param {HTMLElement} element
   */
  destroy(element) {
    // do nothing
  }
};
